import axios from 'axios'
import encryptForge from '../utils/encryptForge'
import { getEnvironmentConfig } from './../utils/getEnvironmentConfig'

const apiclient = axios.create({
  baseURL: getEnvironmentConfig("BASE_URL"),
  headers: {
    'content-type': 'application/json',
    // CORS_ALLOW_ALL_ORIGINS: true,
    // "Access-Control-Allow-Origin": "*",
    // "Access-Control-Allow-Headers": " Content-Type",
    // "Access-Control-Allow-Methods": "POST, GET, OPTIONS, PUT, DELETE",
  },
})

apiclient.interceptors.request.use(
  async (config) => {
    const apikey = sessionStorage.getItem('checkout_current_api_key')
    config.headers['api-key'] = apikey
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const Post = (url, data, encrypte = true) => {
  let payload = data
  if (encrypte) {
    const key = sessionStorage.getItem('checkout_current_encryption_key')
    const encryptedData = encryptForge(JSON.stringify(data), key)
    payload = { data: encryptedData }
  }
  return apiclient.post(url, payload)
}

export const Get = (url) => {
  return apiclient.get(url)
}

export default apiclient
